import { Fragment } from "react";
import './titolo.css'
import TemporaryDrawer from "./bottoni";


function Titolo() {
    return(<Fragment>
        <div style={{ width: "100", color: "white" }}>
          <h1 id="titoloAzienda" style={{ display: "2" }}>
            
          Carrozzeria meccanica  multimarche Daytona
          </h1>
          
          <h2 id="titPiccolo">
          Soccorso stradale
          </h2>
          <br/>
          <br/>
          <br/>
          <br/>
         <TemporaryDrawer/>
        </div>
    </Fragment>)
}

export default Titolo